let outOfStockWrapper = document.getElementById("out-of-stock-drawer");

if (outOfStockWrapper) {


    let activeVariantId = document.querySelector('.form__width input[name="id"]').value;
    const productElemJSON = document.querySelector('[data-product-json]');
    let productJSON = productElemJSON.innerHTML;
    productJSON = JSON.parse(productJSON);

    function returnActiveVariantName(activeVariantId) {
        let variant = productJSON.variants.find((variant) => variant.id == activeVariantId);
        return variant.title;
    }

    function closeDrawer() {
        outOfStockWrapper.classList.remove('is-open');
        outOfStockWrapper?.removeAttribute('data-modal-type');
        document.querySelector('body').classList.remove('scroll-lock');

        outOfStockWrapper.querySelector('.backinstock-btn').classList.remove('d-none');
        outOfStockWrapper.querySelector('.notify-me-btn').classList.add('d-none');
    }

    //close drawer
    document.querySelector('#out-of-stock-drawer .drawer__underlay').addEventListener('click', function () {
        closeDrawer();
    });

    document.querySelector('#out-of-stock-drawer .drawer__close').addEventListener('click', function () {
        closeDrawer()
    });


    let watcher = document.querySelector('.form__width input[name="id"]');

    watcher.addEventListener('change', function () {
        activeVariantId = this.value;
        document.querySelector('.product__selected-size--value').innerHTML = returnActiveVariantName(activeVariantId);
    });

}